import React, { useEffect, useState } from "react";
import {
  Stack,
  TextField,
  InputAdornment,
  Typography,
  Button,
  FormHelperText,
  Autocomplete,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useNavigate, useLocation } from "react-router-dom";
import { checkUserLoggedIn } from "../shared/commonfunctions";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { ISendEmail } from "../shared/dtos";
import routesData from "../shared/routes.json";
import YourDetailsStyles from "../pages/Styles/YourDetails.module.scss";
import YourdetailsImage from "../Components/assets/Images/newLeftImage.svg";
import PhoneInput, {
  formatPhoneNumberIntl,
  getCountryCallingCode,
  isValidPhoneNumber,
} from "react-phone-number-input";

import SnackBar from "../Components/SnackBars/SnackBar";
import mobileviewimage from "../Components/assets/Images/mobileviewgiftbox.svg";

const category = ["NRI", "PIO", "OCI", "Seafarer"];

export default function AccountType() {
  const navigate = useNavigate();
  const countryList = require("country-list");
  const [value, setValue] = useState();
  const [categoryvalue, setCategoryValue] = useState();
  const [emailAddress, setemailAddress] = useState<any>();
  const [errorMessage, setErrorMessage] = useState<any>(false);
  const [message, setMessage] = useState<any>("");
  const [loading, setloading] = useState(false);

  const navigationData = routesData;

  useEffect(() => {
    window.scrollTo(0, 0);
    // checkUserLoggedIn(navigate);
  }, []);

  function sendEmailAddress(name: any, emailid: any) {
    let obj: ISendEmail = {
      // validation_id: validationID,
      email: emailid,
      client_name: name,
      is_gmail_verified: false,
      google_client_id: "",
    };
  }

  return (
    <>
      <div className={YourDetailsStyles.mobileHeader}>
        <p className={YourDetailsStyles.LeftContainerHeadermobileHeader}>
          Invest with Confidence, Anytime, Anywhere With Firstock
        </p>
        <p className={YourDetailsStyles.LeftContainerSubTextmobileHeader}>
          "Seamless. Secure. Smart Investing for Everyone."
        </p>
      </div>
      <div className={YourDetailsStyles.wrapper}>
        <div className={YourDetailsStyles.LeftContainer}>
          <p className={YourDetailsStyles.LeftContainerHeader}>
            Invest with Confidence, Anytime, Anywhere With Firstock
          </p>
          <p className={YourDetailsStyles.LeftContainerSubText}>
            "Seamless. Secure. Smart Investing for Everyone."
          </p>
          <img
            src={YourdetailsImage}
            alt="Image"
            className={YourDetailsStyles.image}
          />
        </div>
        <div className={YourDetailsStyles.RightContainer}>
          <div className={YourDetailsStyles.headerSection}>
            <p className={YourDetailsStyles.signup}>
              Whats your Email address?
            </p>
            <p className={YourDetailsStyles.subText}>
              All Firstock account related information will be sent to this
              address.
            </p>
          </div>

          <div>
            <Formik
              initialValues={{
                // name: "",
                email: "",
              }}
              onSubmit={(values) => {
                //  console.log(values);
                setloading(true);
                setemailAddress(values.email);
                // sendEmailAddress(values.name, values.email);
              }}
            >
              {({ errors, touched, handleChange, values, handleSubmit }) => (
                <Form
                  onKeyDown={(event) => {
                    event.code === "Enter" ||
                      (event.code === "NumpadEnter" && handleSubmit());
                    // event.code.includes("Enter") && handleSubmit()
                  }}
                >
                  <div className={YourDetailsStyles.textfeildSection}>
                    {/* <Typography variant="h5"> Your Details </Typography> */}

                    <div
                      style={{ margin: "20px 0px" }}
                      className={YourDetailsStyles.textfeild}
                    >
                      Select Country of residency
                      <Autocomplete
                        // size="small"
                        fullWidth
                        options={countryList.getData().map((a: any) => a.name)}
                        value={value}
                        onChange={(event: any, newValue: any) => {
                          setValue(newValue);
                        }}
                        id="disable-clearable"
                        disableClearable
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder={"Select Country of residency"}
                            inputProps={{
                              ...params.inputProps,
                            }}
                          />
                        )}
                        // renderTags={() => null}
                      />
                    </div>
                    <div
                      style={{ margin: "10px 0px" }}
                      className={YourDetailsStyles.textfeild}
                    >
                      Select Category
                      <Autocomplete
                        // size="small"
                        fullWidth
                        options={category}
                        value={categoryvalue}
                        onChange={(event: any, newValue: any) => {
                          setCategoryValue(newValue);
                        }}
                        id="disable-clearable"
                        disableClearable
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder={"Select Category"}
                            inputProps={{
                              ...params.inputProps,
                              readOnly: true,
                            }}
                          />
                        )}
                        // renderTags={() => null}
                      />
                    </div>

                    <SnackBar message={message} />

                    <div className={YourDetailsStyles.mobileImage}>
                      <img
                        src={mobileviewimage}
                        alt="Image"
                        className={YourDetailsStyles.imageMobileView}
                      />
                    </div>

                    <div className={YourDetailsStyles.buttonSection}>
                      {/* <ContinueWithGoogle handleCallBack={callBackMessage} />
                      <Typography sx={{ fontSize: "12px", marginLeft: "2px" }}>
                        (or)
                      </Typography> */}
                      {values.email ? (
                        <LoadingButton
                          variant="contained"
                          type="submit"
                          loading={loading}
                          id="yourDetailsContinueButton"
                          className={YourDetailsStyles.button}
                          onClick={() => {
                            handleSubmit();
                          }}
                        >
                          Continue
                        </LoadingButton>
                      ) : (
                        <Button
                          variant="contained"
                          disabled
                          className={YourDetailsStyles.button}
                        >
                          Continue
                        </Button>
                      )}
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </>
  );
}
